import { Input } from '@1trading/react';
import { Search } from 'lucide-react';
import { type FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Hands off to the full User Search page, which reads `q` back out and auto-runs.
export const UserSearchBox = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState('');

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const q = value.trim();
    if (!q) return;
    navigate(`/operations/user-search?q=${encodeURIComponent(q)}`);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="relative">
        <Search className="pointer-events-none absolute top-1/2 left-4 size-5 -translate-y-1/2 text-muted-foreground" />
        <Input
          aria-label="Search users"
          className="h-14 rounded-xl border-2 pl-12 text-base"
          onChange={(event) => setValue(event.target.value)}
          placeholder="Search by name, email, PID, Fast ID, wallet address, or tx hash"
          value={value}
        />
      </div>
    </form>
  );
};
UserSearchBox.displayName = 'UserSearchBox';
